import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { prospectiveSupplierReducer } from './components/supplier_datagrid/prospective_supplier/prospectiveSupplierSlice';
import { strategyReducer } from './components/Strategy/strategySlice';
import { scopeReducer } from './components/Strategy/scopeSlice';
import { adminReducer } from './components/admin/adminSlice';
import { phasesReducer } from './components/phaseTab/phasesSlice';
import { linksReducer } from './components/phaseTab/linksSlice';
import { commentsReducer } from './components/phaseTab/commentSlice';
import { sepPlansReducer } from './shared/slices/sepPlansSlice';
import { rolesReducer } from './shared/slices/rolesSlice';

export const rootReducer = combineReducers({
  prospectiveSupplier: prospectiveSupplierReducer,
  strategy: strategyReducer,
  scope: scopeReducer,
  admin: adminReducer,
  phases: phasesReducer,
  links: linksReducer,
  comments: commentsReducer,
  sepPlans: sepPlansReducer,
  roles: rolesReducer
});

export const store = configureStore({
  reducer: rootReducer
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
